
interface TourReviewsProps {
  reviews: Array<{
    name: string;
    role: string;
    rating: number;
    text: string;
    date: string;
  }>;
  rating: number;
  reviewCount: number;
}

export default function TourReviews({ reviews, rating, reviewCount }: TourReviewsProps) {
  return (
    <section className="py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-3 h-3 bg-[#1A237E] rotate-45"></span>
            <span className="text-sm font-bold text-[#1A237E] tracking-wider">REVIEWS</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900">여행객 후기</h2>
        </div>

        <div className="flex items-center justify-center gap-8 mb-12">
          <div className="text-center">
            <div className="text-6xl font-bold text-gray-900 mb-2">{rating}</div>
            <div className="flex items-center gap-1 justify-center mb-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className={`ri-star-fill ${i < Math.floor(rating) ? 'text-[#FFB300]' : 'text-gray-300'}`}></i>
              ))}
            </div>
            <div className="text-sm text-gray-500">{reviewCount}개 리뷰</div>
          </div>
          <div className="w-px h-20 bg-gray-200"></div>
          <div className="space-y-2">
            {[5, 4, 3, 2, 1].map((star) => {
              const count = reviews.filter(r => r.rating === star).length;
              const pct = reviews.length > 0 ? (count / reviews.length) * 100 : 0;
              return (
                <div key={star} className="flex items-center gap-2 text-sm">
                  <span className="text-gray-600 w-4">{star}</span>
                  <i className="ri-star-fill text-[#FFB300] text-xs"></i>
                  <div className="w-40 h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div className="h-full bg-[#FFB300] rounded-full" style={{ width: `${pct}%` }}></div>
                  </div>
                  <span className="text-gray-400 w-8">{count}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {reviews.map((review, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 bg-[#00BCD4] rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">{review.name}</div>
                  <div className="text-xs text-gray-500">{review.role}</div>
                </div>
                <div className="ml-auto text-xs text-gray-400">{review.date}</div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill text-sm ${i < review.rating ? 'text-[#FFB300]' : 'text-gray-300'}`}></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
